import { CFlex, CMargin, DText, Flex } from '../../../../../styles/CommonStyles'
import Select from '../../../../common/dropdown/Select'
import { useAvailableCoins } from '../../../../../core/services/react-query/setting'
import { useEffect, useMemo, useState } from 'react'
import Text from '../../../../../core/utils/Text'
import { UserDetailSettingBox } from '../../../../../styles/main/user'
import ActionButton from '../../../../common/buttons/ActionButton'
import { useQueryContext } from '../../../../../core/contexts/query'
import {
	useGetAccountingConfig,
	useGetUserManualAccountingConfig,
	useUpdateUserManualAccountingConfig
} from '../../../../../core/services/react-query/setting/accounting'
import { BiX } from 'react-icons/bi'

const FiatSettings = ({ user }) => {

	const { setToast } = useQueryContext()
	const { data: accountingConfig } = useGetAccountingConfig()
	const { data: availableCoins } = useAvailableCoins()

	const { data: userManualAccountingConfig } =
		useGetUserManualAccountingConfig(user?._id)

	const {
		mutate: updateUserManualAccountingConfig,
		isLoading
	} = useUpdateUserManualAccountingConfig()


	const getCoinById = (id) => {
		return filteredCoins.find(c => c.id === id)
	}

	// ---- state
	const [deposit, setDeposit] = useState([])
	const [withdraw, setWithdraw] = useState([])
	const [selectedCoin, setSelectedCoin] = useState(null)

	// ---- initialize from API
	useEffect(() => {
		if (userManualAccountingConfig?.data) {
			setDeposit(userManualAccountingConfig.data.deposit || [])
			setWithdraw(userManualAccountingConfig.data.withdraw || [])
		}
	}, [userManualAccountingConfig])

	// ----- example: remove from deposit
	const removeFromDeposit = (id) => {
		setDeposit(prev => prev.filter(item => item !== id))
	}

	useEffect(() => {
		if (availableCoins) {
			const _irt = availableCoins.find((item) => item.id === 'usd')
			if (!_irt) {
				availableCoins.push({
					id: 'usd',
					fa: 'دلار',
					name: 'Dollar',
				})
			}
		}
	}, [availableCoins])

	const filteredCoins = useMemo(() => {
		if (!accountingConfig) return []
		if (!availableCoins) return []

		const depositCurrencies =
			accountingConfig.deposit?.map(i => i.currency.toLowerCase()) || []

		const withdrawCurrencies =
			accountingConfig.withdraw?.map(i => i.currency.toLowerCase()) || []

		const manualCurrencies = [
			...new Set([...depositCurrencies])
		]

		// فیلتر اصلی از availableCoins
		let result = availableCoins.filter(coin =>
			manualCurrencies.includes(coin.id.toLowerCase())
		)

		// اگر usd تو manual بود ولی تو available نبود، اضافه‌اش کن
		const hasUsdInManual = manualCurrencies.includes('usd')
		const hasUsdInResult = result.some(c => c.id === 'usd')

		if (hasUsdInManual && !hasUsdInResult) {
			result = [
				...result,
				{ id: 'usd', name: 'Dollar', fa: 'دلار' }
			]
		}

		return result
	}, [availableCoins, accountingConfig])

	// ---- select handler
	const onCurrencyChange = (idx) => {
		const coin = availableCoins[idx === 1 ? 16 : idx] // !-- I exactly know that usd is at index 16, but this is not a good practice. Ideally, the API should provide the list of supported currencies for manual accounting.

		if (!coin) return
		setSelectedCoin(coin)
		if (!deposit.includes(coin.id)) {
			setDeposit(prev => [...prev, coin.id])
		}
	}

	const onSubmitClicked = () => {
		updateUserManualAccountingConfig(
			{
				userId: user?._id,
				data: {
					deposit,
					withdraw
				}
			},
			{
				onSuccess: () => {
					setToast({
						type: 'success',
						message: 'Saved successfully'
					})
				},
				onError: () => {
					setToast({
						type: 'error',
						message: 'Something went wrong'
					})
				}
			}
		)
	}

	return (
		<CFlex fw>
			<UserDetailSettingBox>

				<CMargin margin={'8px'} />
				<DText main fontSize={'s'}>
					<Text tid={'currency'} />
				</DText>

				<CMargin margin={'4px'} />
				<Select
					options={filteredCoins}
					value={selectedCoin}
					onValueChange={onCurrencyChange}
					placeHolder={'select-currency'}
					fontSize={'s'}
					width={'100%'}
					height={'42px'}
					isCoin
				/>

				<CMargin margin={'12px'} />

				{deposit.length > 0 && (
					<Flex column gap={'8px'}>
						{deposit.map((id) => {
							const coin = getCoinById(id)

							return (
								<Flex
									key={id}
									justify="space-between"
									align="center"
									style={{
										padding: '8px 12px',
										border: '1px solid #eee',
										borderRadius: '8px'
									}}
								>
									<button
										onClick={() => removeFromDeposit(id)}
										size="small"
									>
										<BiX color='#c33' size={24} />
									</button>
									<DText main>
										{coin?.fa || coin?.name || id}
									</DText>

								</Flex>
							)
						})}
					</Flex>
				)}

				<CMargin margin={'12px'} />

				<ActionButton
					active
					onClick={onSubmitClicked}
					loading={isLoading}
				>
					<Text tid={'submit'} />
				</ActionButton>

			</UserDetailSettingBox>
		</CFlex>
	)
}

export default FiatSettings